import { ITeaserEvent } from '../types/teaser';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendTeaserEvent = (soprApi: string, request: ITeaserEvent): Promise<any> => {
  return fetch(`${soprApi}teaser/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  });
};
